/**
 * 访问埋点工具
 * - 页面加载/导航时上报 pageview
 * - 页面隐藏/关闭时上报 session_end（含停留时长）
 * - 仅在生产域名（yuanniuniu.com）上报，本地开发默认不打扰
 */
const TRACK_ENDPOINT = '/api/track';
const PROD_HOSTS = ['yuanniuniu.com', 'www.yuanniuniu.com'];
const SESSION_TTL_MS = 30 * 60 * 1000;

const VISITOR_KEY = 'yyn_visitor_id';
const SESSION_KEY = 'yyn_session_id';
const SESSION_START_KEY = 'yyn_session_start';

function getVisitorId() {
    try {
        let id = localStorage.getItem(VISITOR_KEY);
        if (!id) {
            id = 'v_' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-6);
            localStorage.setItem(VISITOR_KEY, id);
        }
        return id;
    } catch (e) {
        return 'v_' + Math.random().toString(36).slice(2, 12);
    }
}

function getSessionId() {
    try {
        let id = localStorage.getItem(SESSION_KEY);
        let start = parseInt(localStorage.getItem(SESSION_START_KEY) || '0', 10);
        const now = Date.now();
        if (!id || !start || now - start > SESSION_TTL_MS) {
            id = 's_' + Math.random().toString(36).slice(2, 10) + now.toString(36).slice(-6);
            start = now;
            localStorage.setItem(SESSION_KEY, id);
            localStorage.setItem(SESSION_START_KEY, String(start));
        }
        return id;
    } catch (e) {
        return 's_' + Math.random().toString(36).slice(2, 12);
    }
}

function getPagePath() {
    if (typeof window === 'undefined') return '/';
    return window.location.pathname + window.location.search;
}

function shouldTrack() {
    if (typeof window === 'undefined') return false;
    const host = window.location.hostname;
    if (PROD_HOSTS.indexOf(host) !== -1) return true;
    // 本地开发可通过环境变量强制开启（'true'/'1' 视为开启）
    const envFlag = process.env.REACT_APP_TRACKING_ENABLED;
    return envFlag === 'true' || envFlag === '1';
}

function send(event, payload) {
    if (!shouldTrack()) return;
    const data = {
        event,
        visitorId: getVisitorId(),
        sessionId: getSessionId(),
        page: getPagePath(),
        ts: Date.now(),
        ...payload,
    };
    const body = JSON.stringify(data);
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
        navigator.sendBeacon(TRACK_ENDPOINT, new Blob([body], { type: 'application/json' }));
    } else {
        fetch(TRACK_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body,
            keepalive: true,
        }).catch(() => {});
    }
}

let sessionStartTs = Date.now();
let lastPage = getPagePath();

function trackPageview() {
    const now = Date.now();
    let ua = '';
    let screen = '';
    try {
        ua = navigator.userAgent;
        screen = `${window.screen.width}x${window.screen.height}`;
    } catch (e) { /* ignore */ }
    send('pageview', {
        referrer: typeof document !== 'undefined' ? document.referrer : '',
        ua,
        screen,
    });
    sessionStartTs = now;
    lastPage = getPagePath();
}

function trackSessionEnd() {
    const dur = Math.round((Date.now() - sessionStartTs) / 1000);
    if (dur < 1) return;
    send('session_end', {
        page: lastPage,
        dur,
    });
}

let started = false;

export function startTracking() {
    if (started) return;
    started = true;

    trackPageview();

    // SPA 路由为整页跳转（a 标签 href），每次导航都会重新加载页面，
    // 因此无需监听 history 变化，直接监听页面隐藏/关闭即可。
    if (typeof document !== 'undefined') {
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') {
                trackSessionEnd();
            }
        });
    }
    if (typeof window !== 'undefined') {
        window.addEventListener('pagehide', trackSessionEnd);
        window.addEventListener('beforeunload', trackSessionEnd);
    }
}
